<app-background>
    <!-- login page main div -->
    <div class="login-page-wrapper">
        <form [formGroup]="loginForm">
            <!-- login container contain two div i.e. top & bottom section -->
            <div class="login-container">
                <!-- logo -->
                <div class="top-section">
                    <div class="logo">
                        <img src="../../../assets/images/funfigz-logo.png" class="logo-image" alt="Logo" />
                    </div>
                </div>

                <div class="divider"></div>

                <div class="bottom-section" *ngIf="!showOTPField">
                    <div class="header-section">
                        <h1 class="font-poppins">Welcome 👋</h1>
                        <p class="font-inter">Sign in using your mobile number to continue</p>
                    </div>

                    <div class="body-section">
                        <div class="mobile-input-container">
                            <h5 class="font-inter">Registered Mobile Number</h5>

                            <mat-form-field appearance="outline" class="input-border-radius">
                                <!-- Prefix: icon + country code -->
                                <span matPrefix class="phone-prefix font-inter">
                                    <mat-icon>phone_iphone</mat-icon>
                                    <span class="country-code">+91</span>
                                    <span class="divider"></span>
                                </span>

                                <input
                                    matInput
                                    type="tel"
                                    formControlName="mobileNumber"
                                    maxlength="10"
                                    autocomplete="off"
                                    placeholder="Enter your mobile number"
                                    class="font-inter"
                                />
                                <mat-error *ngIf="loginForm.get('mobileNumber')?.hasError('required')">
                                    Mobile number is required
                                </mat-error>

                                <mat-error *ngIf="loginForm.get('mobileNumber')?.hasError('pattern')">
                                    Please enter a valid mobile number
                                </mat-error>
                            </mat-form-field>
                            <p class="font-inter">We'll send you an OTP to verify your number</p>
                        </div>

                        <!-- WhatsApp OTP Section -->
                        <div class="whatsapp-section">
                            <div class="left">
                                <img src="assets/icons/whatsapp.svg" alt="whatsapp" />
                                <div class="text">
                                    <span class="title">Get OTP on WhatsApp</span>
                                    <span class="sub">Faster & more reliable delivery</span>
                                </div>
                            </div>

                            <!-- Toggle Switch -->
                            <mat-slide-toggle formControlName="isWhatsappOtp" class="slide-toggle"> </mat-slide-toggle>
                        </div>

                        <div class="checkbox-section">
                            <mat-checkbox formControlName="agreeTerms">
                                <span class="font-inter">
                                    By continuing, I agree to the
                                    <a href="/terms-and-conditions">Terms of Use</a> &amp;
                                    <a href="/privacy-policy">Privacy Policy</a>
                                </span>
                            </mat-checkbox>

                            <button
                                mat-flat-button
                                [disabled]="loginForm.invalid || isSubmitting"
                                class="continue-btn"
                                (click)="sendOTP()"
                            >
                                <ng-container *ngIf="!isSubmitting; else loading"> Continue → </ng-container>
                                <ng-template #loading>
                                    <mat-progress-spinner diameter="30" mode="indeterminate" color="accent">
                                    </mat-progress-spinner>
                                </ng-template>
                            </button>
                        </div>

                        <div class="security font-inter">
                            <span class="security-item">
                                <mat-icon svgIcon="shield"></mat-icon>
                                Secure Login
                            </span>

                            <div class="security-divider"></div>

                            <span class="security-item">
                                <mat-icon svgIcon="lock"></mat-icon>
                                Data Protected
                            </span>
                        </div>
                    </div>

                    <div class="support-section font-inter">
                        <span> Need help?</span> <a href="/contact">Contact Support</a>
                    </div>
                </div>

                <!-- Verify -->
                <div class="verify-container" *ngIf="showOTPField">
                    <!-- title-we-no. -->
                    <div class="verify-heading-section">
                        <h2 class="font-poppins">Verify Your Number 🔐</h2>
                        <div class="verify-content font-inter">
                            <p>We've sent a 6-digit OTP to</p>
                            <span>+91{{ maskedMobile }}</span>
                        </div>

                        <div class="whatsapp-badge" *ngIf="loginForm.get('isWhatsappOtp')?.value">
                            <div class="icon">
                                <img src="assets/icons/whatsapp.svg" alt="whatsapp" />
                            </div>
                            <span class="font-inter">Sent via WhatsApp</span>
                        </div>
                    </div>

                    <!-- otp-re-button-chnage -->
                    <div class="verify-bottom">
                        <ng-otp-input
                            [config]="{ length: 6, allowNumbersOnly: true }"
                            (onInputChange)="onOtpChange($event)"
                            *ngIf="!showResendLink"
                        ></ng-otp-input>
                        <p class="invalid-otp" *ngIf="!isSubmitting && !showResendLink">
                            {{ otpFailedMessage }}
                        </p>
                        <div class="resend-text font-inter" *ngIf="!isSubmitting && showTimer">
                            Resend OTP in
                            <span [ngClass]="{ 'blink-alert': seconds < 30 && minutes < 1 }">{{ timerDuration }}</span>
                        </div>

                        <div class="button-section">
                            <!-- Verify-Button -->
                            <button
                                class="verify-btn"
                                *ngIf="!showResendLink"
                                [disabled]="loginForm.invalid || isSubmitting || isInputFieldInValid()"
                                (click)="submitOTP()"
                            >
                                <ng-container *ngIf="!isSubmitting; else loading">
                                    Verify &amp; Continue →
                                </ng-container>
                                <ng-template #loading>
                                    <mat-progress-spinner diameter="30" mode="indeterminate" color="accent">
                                    </mat-progress-spinner>
                                </ng-template>
                            </button>
                            <!-- Resend-OTP button -->
                            <button class="verify-btn" *ngIf="showResendLink" (click)="resendOTP()">
                                <ng-container *ngIf="!isSubmitting; else loading"> Resend OTP </ng-container>
                                <ng-template #loading>
                                    <mat-progress-spinner diameter="30" mode="indeterminate" color="accent">
                                    </mat-progress-spinner>
                                </ng-template>
                            </button>

                            <!-- Change-text -->
                            <a class="change font-inter" href="/login">
                                <mat-icon class="edit-icon" svgIcon="pencil"></mat-icon>
                                Change mobile number
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</app-background>
